module.exports = __webpack_public_path__ + "img/14b-doc-acao-revisao.c086a095.png";